// `addToJobATSCopyOptions` / `exportTooltipCopyOptions`
// (`extension-alert-candidate-profile-actions-provider.service.ng1.ts:100-108`).
//
// ⚠️ TWO ACTIONS NAME THE ATS AND THE REST DO NOT, and the port had the default for both.
// Upstream keys each off `careero.atsName`, with Bullhorn the only entry in either table —
// so on a Bullhorn tenant the bulk bar reads "Add to Bullhorn job" and "Export to Bullhorn
// hotlist/tearsheet", and this build read "Add to job" and "Export". Measured by inventorying
// the actions on both builds' review screens: the label was the whole difference.
//
// `ShortlistReview` carried a private copy of the add-to-job half for the row strip and
// nothing supplied either to `bulkActions`, which is how one screen ended up saying both.

/** `ATSType.BULLHORN` as `careero.atsName` spells it. */
const BULLHORN = 'Bullhorn'

/** `addToJobATSCopyDefault` + its one override. */
export function addToJobTitle(atsName: string | undefined): string {
  return atsName === BULLHORN ? 'Add to Bullhorn job' : 'Add to job'
}

/** `exportTooltipCopyDefault` + its one override. */
export function exportTitle(atsName: string | undefined): string {
  return atsName === BULLHORN ? 'Export to Bullhorn hotlist/tearsheet' : 'Export'
}
